/* eslint-disable react/self-closing-comp */
/* eslint-disable react/sort-comp */
/* eslint-disable no-underscore-dangle */
/* eslint-disable class-methods-use-this */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ALL, SELECTED } from '../../../Utils/Constants/GlobalConstants';
import './css/ResortFilter.css';
import {
  changeHotelsFilter,
  changeRegionsOptions,
  changeIsAllRegionsFilterTab,
} from '../../../DataStore/actions/FiltersAction';
import { ReactComponent as ClearCross } from '../../../images/clear-cross-r.svg';
import { ReactComponent as BlackArrow } from '../../../images/black-arrow-r.svg';
import { ReactComponent as DefaultCheck } from '../../../images/default-check-r.svg';
import { ReactComponent as ActiveCheck } from '../../../images/active-check-r.svg';

const mapStateToProps = (state) => ({ ...state });

class ResortFilter extends React.Component {
  constructor() {
    super();

    this.state = {};
  }

  compareName = (a, b) => {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }

    return 0;
  };

  hadleCheckBox = (item) => {
    const {
      handleRegionFilter,
      regionsOptions,
      changeRegionsOptions: changeRegionsOptionsAction,
    } = this.props;

    let newState;
    if (item.type === 'region') {
      newState = regionsOptions.map((region) => {
        if (region.id === item.id) {
          return {
            ...region,
            checked: !region.checked,
            subregions: item.subregions.map((sub) => ({
              ...sub,
              checked: !region.checked,
            })),
          };
        }

        return region;
      });
    } else {
      newState = regionsOptions.map((region) => {
        if (region.id === item.parentregionId) {
          const newSubregionsState = region.subregions.map((sub) => {
            if (sub.id === item.id) {
              return { ...sub, checked: !sub.checked };
            }

            return sub;
          });

          return {
            ...region,
            checked:
              newSubregionsState.filter((sub) => sub.checked === true).length >
              0,
            subregions: newSubregionsState,
          };
        }

        return region;
      });
    }

    const selectedResorts = newState.filter((i) => i.checked === true);

    if (selectedResorts.length === 0) {
      newState = newState.map((e) => ({ ...e, subregionsVisible: false }));
    }

    handleRegionFilter(newState);
    changeRegionsOptionsAction(newState);
  };

  renderRegions = (regions) =>
    regions.map((region) => (
      <div key={`region-${region.id}`}>
        <div className="rf_region_item_w">
          <button
            type="button"
            className="filter_description"
            onClick={() => this.hadleCheckBox(region)}
          >
            {region.checked ? (
              <ActiveCheck className="tr_filter_check" />
            ) : (
              <DefaultCheck className="tr_filter_check" />
            )}
            <div>{region.name}</div>
          </button>
          {region.subregions.length > 0 && (
            <div className="tr_region_count_w">
              {region.subregions.filter((e) => e.checked).length > 0 && (
                <div>{`(${
                  region.subregions.filter((e) => e.checked).length
                })`}</div>
              )}

              <button
                type="button"
                onClick={() => this.showSubregions(region)}
                className="rf_arrow_button"
              >
                <BlackArrow
                  className={
                    region.subregionsVisible ? 'rf_arrow_rotated' : 'rf_arrow'
                  }
                />
              </button>
            </div>
          )}
        </div>

        {region.subregionsVisible && (
          <div>{this.renderSubregions(region.subregions)}</div>
        )}
      </div>
    ));

  renderSubregions = (subregions) =>
    subregions.map((subregion) => (
      <button
        key={`subregion-${subregion.id}`}
        type="button"
        className="filter_description rf_subregion_w"
        onClick={() => this.hadleCheckBox(subregion)}
      >
        {subregion.checked ? (
          <ActiveCheck className="tr_filter_check" />
        ) : (
          <DefaultCheck className="tr_filter_check" />
        )}
        <div>{subregion.name}</div>
      </button>
    ));

  renderSelectedSubregions = (subregions) =>
    subregions.map((subregion) => (
      <button
        key={`selected-subregion-${subregion.id}`}
        type="button"
        className="filter_description"
        onClick={() => this.hadleCheckBox(subregion)}
      >
        {subregion.checked ? (
          <ActiveCheck className="tr_filter_check" />
        ) : (
          <DefaultCheck className="tr_filter_check" />
        )}
        <div>{subregion.name}</div>
      </button>
    ));

  showSubregions = (region) => {
    const { changeRegionsOptions: changeRegionsOptionsAction, regionsOptions } =
      this.props;

    const newState = regionsOptions.map((item) => {
      if (item.id === region.id) {
        return { ...item, subregionsVisible: !item.subregionsVisible };
      }

      return item;
    });

    changeRegionsOptionsAction(newState);
  };

  handleTabClick = (isAllTabNew) => {
    const {
      regionsOptions,
      changeRegionsOptions: changeRegionsOptionsAction,
      changeIsAllRegionsFilterTab: changeIsAllRegionsFilterTabAction,
      isAllRegionsFilterTab,
    } = this.props;

    if (isAllRegionsFilterTab !== isAllTabNew) {
      if (isAllTabNew) {
        const regionsNewState = regionsOptions.map((item) => {
          const sub = item.subregions;

          if (sub.length > 0) {
            const checkedSubCount = sub.filter(
              (e) => e.checked === true,
            ).length;

            return {
              ...item,
              subregionsVisible:
                checkedSubCount > 0 && sub.length !== checkedSubCount,
            };
          }

          return item;
        });

        changeIsAllRegionsFilterTabAction(true);
        changeRegionsOptionsAction(regionsNewState);
      } else {
        changeIsAllRegionsFilterTabAction(false);
      }
    }
  };

  getSelectedResorts = () => {
    const { selectedResorts } = this.props;
    const result = [];

    selectedResorts.forEach((region) => {
      if (region.checked) {
        const sub = region.subregions;

        if (sub) {
          if (sub.length === sub.filter((i) => i.checked).length) {
            result.push(region);
          } else {
            sub.forEach((subRegion) => {
              if (subRegion.checked) {
                result.push(subRegion);
              }
            });
          }
        }
      }
    });

    return result.sort(this.compareName);
  };

  handleClear = () => {
    const {
      handleRegionFilter,
      regionsOptions,
      changeRegionsOptions: changeRegionsOptionsAction,
    } = this.props;

    const newState = regionsOptions.map((region) => ({
      ...region,
      checked: false,
      subregions: region.subregions.map((sub) => ({
        ...sub,
        checked: false,
      })),
      subregionsVisible: false,
    }));

    handleRegionFilter(newState);
    changeRegionsOptionsAction(newState);
  };

  render() {
    const { regionsOptions, isAllRegionsFilterTab } = this.props;

    const sortedRegions = regionsOptions
      .filter((item) => item.type === 'region')
      .sort(this.compareName);

    const selected = this.getSelectedResorts();

    return (
      <div>
        <div className="rf_button_w">
          <button
            type="button"
            className={
              isAllRegionsFilterTab ? 'rf_button tab_selected' : 'rf_button'
            }
            onClick={() => this.handleTabClick(true)}
          >
            {ALL}
          </button>
          {selected.length > 0 && (
            <div className="rf_selected_button_w">
              <button
                type="button"
                className={
                  isAllRegionsFilterTab ? 'rf_button' : 'rf_button tab_selected'
                }
                onClick={() => this.handleTabClick(false)}
              >
                <div>{SELECTED}</div>
                <div className="rf_selected_count">{selected.length}</div>
              </button>
              <button type="button" onClick={this.handleClear}>
                <ClearCross />
              </button>
            </div>
          )}
        </div>

        {isAllRegionsFilterTab ? (
          <div className="rf_hotels_w custom_scroll_container">
            {this.renderRegions(sortedRegions)}
          </div>
        ) : (
          <div className="rf_hotels_w custom_scroll_container">
            {this.renderSelectedSubregions(selected)}
          </div>
        )}
      </div>
    );
  }
}

ResortFilter.propTypes = {
  selectedResorts: PropTypes.instanceOf(Array).isRequired,
  handleRegionFilter: PropTypes.func.isRequired,
  changeRegionsOptions: PropTypes.func.isRequired,
  regionsOptions: PropTypes.instanceOf(Array).isRequired,
  isAllRegionsFilterTab: PropTypes.bool.isRequired,
  changeIsAllRegionsFilterTab: PropTypes.func.isRequired,
};

ResortFilter.defaultProps = {};

export default connect(mapStateToProps, {
  changeHotelsFilter,
  changeRegionsOptions,
  changeIsAllRegionsFilterTab,
})(ResortFilter);
